import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { userRequest } from "../requestMethods";
import { clearCart } from "../redux/cartRedux";
import CryptoJS from "crypto-js";

const Success = () => {
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);
    
    // Check if this is a SenangPay return
    const isSenangPayReturn = urlParams.has('status_id') && urlParams.has('order_id') && urlParams.has('hash');
    
    const data = location.state
        ? location.state.address
        : undefined;
    const gateway = location.state ? location.state.gateway : (isSenangPayReturn ? 'senangpay' : undefined);
    const cart = location.state ? location.state.products : undefined;
    const serialCode = location.state ? location.state.serialCode : undefined;
    const currentUser = useSelector((state) => state.user.currentUser);
    const [orderId, setOrderId] = useState(null);
    const [invoiceId, setInvoiceId] = useState(null);
    const [senangPayResult, setSenangPayResult] = useState(null);
    const dispatch = useDispatch();

    // SenangPay configuration (should match Cart.jsx)
    const SENANGPAY_SECRET_KEY = "SK-4Yx5uZYvJZJrmRBpWmvq";

    let totalPrice = 0

    let totalDiscount = 0

    // SenangPay verification function (matching Cart.jsx)
    // HMAC-SHA256 with sequence: secretKey + status_id + order_id + transaction_id + msg
    const verifySenangPayHash = (secretKey, statusId, orderId, transactionId, msg) => {
        const str = secretKey + statusId + orderId + transactionId + msg;
        return CryptoJS.HmacSHA256(str, secretKey).toString();
    };

    useEffect(() => {
        if (isSenangPayReturn) {
            // Handle SenangPay return
            const statusId = urlParams.get('status_id');
            const orderIdParam = urlParams.get('order_id');
            const msg = urlParams.get('msg');
            const transactionId = urlParams.get('transaction_id');
            const receivedHash = urlParams.get('hash');

            // Log all received parameters
            console.log('=== SenangPay Return Parameters ===');
            console.log('Status ID:', statusId);
            console.log('Order ID:', orderIdParam);
            console.log('Message:', msg);
            console.log('Transaction ID:', transactionId);
            console.log('Received Hash:', receivedHash);
            console.log('================================');

            // Create string for verification (same sequence as documentation)
            const verificationString = SENANGPAY_SECRET_KEY + statusId + orderIdParam + transactionId + msg;
            console.log('Verification String:', verificationString);

            // Generate hash using HMAC-SHA256 (matching Cart.jsx)
            const generatedHash = verifySenangPayHash(SENANGPAY_SECRET_KEY, statusId, orderIdParam, transactionId, msg);
            console.log('Generated Hash:', generatedHash);
            console.log('Hashes Match:', generatedHash === receivedHash);

            // Decode message (replace underscores with spaces)
            const decodedMessage = msg ? msg.replace(/_/g, ' ') : '';
            
            // Determine payment status
            const paymentStatus = {
                '0': 'Failed',
                '1': 'Successful', 
                '2': 'Pending Authorization'
            };

            const statusText = paymentStatus[statusId] || 'Unknown';

            console.log('=== Decoded Information ===');
            console.log('Payment Status:', statusText);
            console.log('Decoded Message:', decodedMessage);
            console.log('Order ID:', orderIdParam);
            console.log('Transaction ID:', transactionId);
            console.log('==========================');

            
            if (generatedHash === receivedHash) {
                console.log('✅ Hash verification PASSED - Data is authentic');
                
                // Hash is valid
                if (statusId === '1') {
                    // Payment successful - update order status to completed
                    console.log('✅ Payment was SUCCESSFUL');
                    
                    // Get the pending order ID from localStorage
                    const pendingOrderId = localStorage.getItem('pendingOrderId');
                    const senangpayOrderId = localStorage.getItem('senangpayOrderId');
                    
                    console.log('Pending Order ID from localStorage:', pendingOrderId);
                    console.log('SenangPay Order ID from localStorage:', senangpayOrderId);
                    console.log('SenangPay Order ID from URL:', orderIdParam);
                    
                    // Update order status to completed
                    if (pendingOrderId) {
                        userRequest.put(`/orders/${pendingOrderId}`, {
                            status: "pending",
                            transactionId: transactionId
                        })
                        .then(response => {
                            console.log('✅ Order updated to completed:', response.data);
                            setOrderId(response.data._id);
                            setInvoiceId(response.data.invoiceId);
                            
                            // Clear localStorage
                            localStorage.removeItem('pendingOrderId');
                            localStorage.removeItem('senangpayOrderId');
                            
                            // Clear cart on successful payment
                            dispatch(clearCart());
                        })
                        .catch(error => {
                            console.error('❌ Error updating order:', error);
                        });
                    }
                    
                    setSenangPayResult({
                        success: true,
                        message: decodedMessage,
                        orderId: orderIdParam,
                        transactionId: transactionId,
                        statusText: statusText
                    });
                } else if (statusId === '2') {
                    // Pending authorization
                    console.log('⏳ Payment is PENDING AUTHORIZATION');
                    setSenangPayResult({
                        success: false,
                        message: decodedMessage,
                        orderId: orderIdParam,
                        transactionId: transactionId,
                        statusText: statusText
                    });
                } else {
                    // Payment failed - update order status to failed
                    console.log('❌ Payment FAILED');
                    
                    // Get the pending order ID from localStorage
                    const pendingOrderId = localStorage.getItem('pendingOrderId');
                    
                    // Update order status to failed
                    if (pendingOrderId) {
                        userRequest.put(`/orders/${pendingOrderId}`, {
                            status: "failed"
                        })
                        .then(response => {
                            console.log('Order updated to failed:', response.data);
                            
                            // Clear localStorage
                            localStorage.removeItem('pendingOrderId');
                            localStorage.removeItem('senangpayOrderId');
                        })
                        .catch(error => {
                            console.error('Error updating order to failed:', error);
                        });
                    }
                    
                    setSenangPayResult({
                        success: false,
                        message: decodedMessage,
                        orderId: orderIdParam,
                        transactionId: transactionId,
                        statusText: statusText
                    });
                }
            } else {
                console.error('❌ Hash verification FAILED - Data may have been tampered with');
                console.error('Expected:', generatedHash);
                console.error('Received:', receivedHash);
                
                setSenangPayResult({
                    success: false,
                    message: 'Hash verification failed - data may have been tampered with',
                    orderId: orderIdParam,
                    transactionId: transactionId,
                    statusText: 'Security Error'
                });
            }
        } else if (data === undefined) {
            alert("Please make a valid purchase");
            window.location.href = "/";
        }
    }, [isSenangPayReturn, urlParams, dispatch]);

    useEffect(() => {
        const createOrder = async () => {
            try {
                if (cart.length === 0) {
                    alert("No product added!!");
                    return;
                }

                const paypalAddress = `${data.address_line_1 ? `${data.address_line_1},` : ""}${
                    data.address_line_2 ? `${data.address_line_2},` : ""
                }${data.postal_code ? `${data.postal_code},` : ""}${
                    data.admin_area_2 ? `${data.admin_area_2},` : ""
                }${data.admin_area_1 ? `${data.admin_area_1},` : ""}${
                    data.country_code ? `${data.country_code},` : ""
                }`

                const stripeAddress = `${data.line1 ? `${data.line1},` : ""}${
                    data.line2 ? `${data.line2},` : ""
                }${data.postal_code ? `${data.postal_code},` : ""}${
                    data.state ? `${data.state},` : ""
                }${data.city ? `${data.city},` : ""}${
                    data.country ? `${data.country},` : ""
                }`

                const res = await userRequest.post("/orders", {
                    userId: currentUser._id,
                    products: cart.products.map((item) => ({
                        productId: item._id,
                        quantity: item.quantity,
                        code: `${item.model}-${item.color.color.name}`,
                        img: item.color.color.img,
                    })),
                    amount: totalPrice,
                    discount: totalDiscount + cart.discount,
                    affiliateCode: serialCode,
                    address: gateway === "paypal" ? paypalAddress : stripeAddress,
                    cashier: currentUser ? currentUser._id : undefined,
                    paymentType: gateway === "paypal" ? "paypal" : "ecommerce"
                });
                setOrderId(res.data._id);
                setInvoiceId(res.data.invoiceId);
                dispatch(clearCart());
                window.location.href = "/order";
            } catch {}
        };
        data && createOrder();
    }, [cart, data, currentUser, dispatch, serialCode, gateway, totalDiscount, totalPrice]);

    return (
        <div
            style={{
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                background: senangPayResult ? (senangPayResult.success ? "#28a745" : "#dc3545") : "black",
                color: "white",
            }}
        >
            {senangPayResult ? (
                // SenangPay result display
                <div style={{ textAlign: "center", padding: "20px" }}>
                    <h2>{senangPayResult.success ? "Payment Successful!" : "Payment Failed"}</h2>
                    <p style={{ fontSize: "18px", margin: "20px 0" }}>
                        {senangPayResult.message}
                    </p>
                    <p>Order ID: {senangPayResult.orderId}</p>
                    <p>Transaction ID: {senangPayResult.transactionId}</p>
                    {senangPayResult.success && orderId && invoiceId && (
                        <p style={{ color: "#90EE90", marginTop: "20px" }}>
                            Your order has been created successfully.<br/>
                            Order Number: {orderId}<br/>
                            Invoice Number: {invoiceId}
                        </p>
                    )}
                    {senangPayResult.success && !orderId && (
                        <p style={{ color: "#90EE90", marginTop: "20px" }}>
                            Your order has been processed and will be prepared shortly.
                        </p>
                    )}
                </div>
            ) : (
                // Original success display for other payment methods
                <div style={{ textAlign: "center" }}>
                    {orderId
                        ? `Order has been created successfully. Your order number is ${orderId} - Invoice number : ${invoiceId}`
                        : `Successful. Your order is being prepared...`}
                </div>
            )}
            <button
                style={{ 
                    padding: "10px 20px", 
                    marginTop: 20, 
                    backgroundColor: "white", 
                    color: "black",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer"
                }}
                onClick={() => (window.location.href = "/")}
            >
                Go to Homepage
            </button>
        </div>
    );
};

export default Success;
